var LEFT_KEY = 37;
var UP_KEY = 38;
var RIGHT_KEY = 39;
var DOWN_KEY = 40;
var SPACEBAR_KEY = 32;
var PAGEUP_KEY = 33;
var PAGEDOWN_KEY = 34;
var END_KEY = 35;
var HOME_KEY = 36;
export var SCROLL_KEYS = [LEFT_KEY, UP_KEY, RIGHT_KEY, DOWN_KEY, SPACEBAR_KEY, PAGEUP_KEY, PAGEDOWN_KEY, END_KEY, HOME_KEY];